'use strict';

goog.provide("Ntry");
goog.require("Ntry.STATIC");
goog.require("Ntry.SystemManager");
goog.require("Ntry.EntityManager");
goog.require("Ntry.initialize");


goog.require("Ntry.Engine");

window['Ntry'] = Ntry;

Ntry.clear = function() {
    if(Ntry.entityManager) {
        Ntry.entityManager.clear();
    }
};

Ntry.update = function() {
    Ntry.systemManager.update.call(Ntry.systemManager);
};

// 코딩파티 미션 통과했으나 특수한 경우(재현불가) 통과못한 것처럼 팝업창이
// 뜨는 문제를 해결하기 위한 메소드들.
Ntry.setSkipLevelLimitCheck = function() {
    window.sessionStorage.setItem('skipLevelLimitCheck', 'true');
};

Ntry.isSkipLevelLimitCheck = function() {
    return window.sessionStorage.getItem('skipLevelLimitCheck')
};

Ntry.resetSkipLevelLimitCheck = function() {
    window.sessionStorage.removeItem('skipLevelLimitCheck')
};

Ntry.getInputLimitChecker = function(limitCount) {
    return function(e) {
        if (this.value.length > limitCount) {
            this.value = this.value.substring(0, limitCount);
            this.blur();
            // '이름은 최대 10자까지 입력하실 수 있습니다.'
            alert('이름은 최대 ' + limitCount + '자까지 입력하실 수 있습니다.');
        }
    };
};
